import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './BottomCTA.css';

export const BottomCTA = () => {
    return (
        <section className="bottom-cta-section">
            <div className="bottom-cta-container">
                <span className="bottom-cta-tag">Start Your Journey</span>
                <h2 className="bottom-cta-title">Ready to Dominate Content?</h2>
                <p className="bottom-cta-desc">
                    Join thousands of creators using AI to automate their workflow and grow their audience 10x faster.
                </p>

                <div className="bottom-cta-buttons">
                    <Link to="/signup" className="cta-btn cta-btn-primary">
                        Get Started For Free
                        <ArrowRight size={20} />
                    </Link>
                    <Link to="/signin" className="cta-btn cta-btn-secondary">
                        Sign In
                    </Link>
                </div>
            </div>
        </section>
    );
};
